export const STORAGE_KEYS = {
  REMIND_LATER: 'REMIND_LATER',
  DMA: 'DMA',
}

export const STORAGE_STEPS = {
  GENERAL: 'GENERAL',
}
